module.exports = __webpack_public_path__ + "static/img/secret-fzj.4db8955a.png";